import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "d-flex flex-nowrap align-center" };
import { useAddressToken } from '@core/composables/AddressTokens/addressTokens.composable';
import { useCoinData } from '@core/composables/CoinData/coinData.composable';
import AddressBalanceTotals from './components/AddressBalanceTotals.vue';
import AppTokenIconRow from '@/core/components/AppTokenIconRow.vue';
import { toRefs, computed } from 'vue';
import { TOKEN_FILTER_VALUES } from '@module/address/models/TokenSort';
import { useGetOwnersNftBalanceQuery } from '@module/address/apollo/AddressTokens/tokens.generated';
import { formatIntegerValue } from '@core/helper/number-format-helper';
import BigNumber from 'bignumber.js';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModuleAddressTokenBalance',
    props: {
        addressRef: {
            type: String,
            required: true
        }
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const { addressRef } = toRefs(props);
        const { initialLoad, tokenBalance, tokenCount, tokenSort } = useAddressToken(addressRef, 'cache-only');
        const { loading: loadingMarketInfo } = useCoinData();
        const { result: nftCountRes, loading: loadingNftCount } = useGetOwnersNftBalanceQuery(() => ({
            address: props.addressRef
        }));
        const nftCount = computed(() => {
            if (!loadingNftCount.value && nftCountRes.value) {
                return formatIntegerValue(new BigNumber(nftCountRes.value?.getOwnersNFTBalance.balance)).value;
            }
            return '0';
        });
        const tokenIcons = computed(() => {
            if (tokenSort.value) {
                return tokenSort.value
                    ?.getSortedTokens(TOKEN_FILTER_VALUES[5])
                    .slice(0, 10)
                    .map(i => {
                    return i.image;
                })
                    .reverse()
                    .filter(i => i !== '');
            }
            return [];
        });
        const tokenCountSubtext = computed(() => {
            return tokenCount.value === 1 ? t('token.tokenTotal') : t('token.tokenTotal', { n: tokenCount.value });
        });
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                fluid: "",
                class: "pa-4 pa-sm-6 fill-height",
                elevation: "1",
                rounded: "xl"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(AddressBalanceTotals, {
                            title: _ctx.$t('block.tokenBalance'),
                            "is-loading": _unref(initialLoad) || _unref(loadingMarketInfo),
                            balance: _unref(tokenBalance).value,
                            "balance-tooltip": _unref(tokenBalance).tooltipText,
                            subtext: _unref(tokenCountSubtext)
                        }, null, 8, ["title", "is-loading", "balance", "balance-tooltip", "subtext"]),
                        (!_unref(loadingMarketInfo) && !_unref(initialLoad))
                            ? (_openBlock(), _createBlock(AppTokenIconRow, {
                                key: 0,
                                tokens: _unref(tokenIcons)
                            }, null, 8, ["tokens"]))
                            : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_divider, { class: "my-6" }),
                    _createVNode(AddressBalanceTotals, {
                        title: _ctx.$t('block.nftTotal'),
                        "is-loading": _unref(loadingNftCount),
                        balance: _unref(nftCount)
                    }, null, 8, ["title", "is-loading", "balance"])
                ]),
                _: 1
            }));
        };
    }
});
